const root = document.querySelector(":root");
const defaultColor = window
  .getComputedStyle(root)
  .getPropertyValue("--gradient-base-background-1");
var sectionColor = "";

function handler(entries) {
  entries.forEach((entry) => {
    let ratio = entry.intersectionRatio;
    let color = entry.target.getAttribute("data-bg");
    sectionColor = color;

    if (ratio >= 1) {
      entry.target.setAttribute("data-intersect", "full");
      root.style.setProperty("--gradient-base-background-1", color);
    } else if (ratio <= 0) {
      entry.target.setAttribute("data-intersect", "non");
      if (
        window
          .getComputedStyle(root)
          .getPropertyValue("--gradient-base-background-1") == sectionColor
      ) {
        root.style.setProperty("--gradient-base-background-1", defaultColor);
      }
    } else {
      entry.target.setAttribute("data-intersect", "partial");
    }
  });
}

const colorSections = document.querySelectorAll(".background-transition");
const colorObserver = new IntersectionObserver(handler, {
  threshold: [0, 1],
});
if (colorSections) {
  colorSections.forEach((el) => colorObserver.observe(el));
}

//Splash observer
const splashObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    let splash = entry.target.querySelector(".item-full_splash");
    if (splash) {
      if (entry.isIntersecting) {
        if (entry.target.getAttribute("aria-hidden") == "false") {
          splash.classList.add("show-mobile");
        }
      } else {
        splash.classList.remove("show-mobile");
        splash.classList.remove("show");
      }
    }
  });
});

const listItems = document.querySelectorAll(
  ".multicolumn-list__item.dawnworks"
);
listItems.forEach((el) => splashObserver.observe(el));

//Scroll to top
const scrollTop = document.querySelector(".scrolltop");
if (scrollTop) {
  scrollTop.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
}

let variantContainer = document.querySelectorAll(".variant-container");
if (variantContainer.length) {
  const paywhirl = document.querySelector(".paywhirl-plan-selector");
  document.querySelector(".variant-buttons").appendChild(paywhirl);
  variantContainer.forEach((variant) => {
    let plus = variant.querySelector("button[name='plus']");
    let minus = variant.querySelector("button[name='minus']");
    let input = variant.querySelector("input");
    plus.addEventListener("click", () => {
      let count = checkVariantQuantity();
      if (count < 12) {
        input.setAttribute("value", input.value++);
        count++;
        minus.classList.remove("disabled");
        updateCount(count);
      }
    });
    minus.addEventListener("click", () => {
      if (input.value > 0) {
        input.setAttribute("value", input.value--);
        if (input.value == "0") {
          minus.classList.add("disabled");
        }
        let count = checkVariantQuantity();
        updateCount(count);
      }
    });
  });

  var disableBuyButtonInterval = setInterval(() => {
    let btn = document.querySelector("button[name='add']");
    if (btn) {
      btn.innerText = btn.innerText.replace("*", 11);
      clearInterval(disableBuyButtonInterval);
    }
  }, 500);
}

function checkVariantQuantity() {
  let inputs = document.querySelectorAll(".variant-container input");
  let count = 0;
  inputs.forEach((input) => {
    count += parseInt(input.value);
  });
  return count;
}

function updateCount(count) {
  let mixContainer = document.querySelector(".mix-container");
  let btnAdd = document.querySelector("button[name='add']");
  let inputs = document.querySelectorAll(".variant-container input");
  if (count == 12) {
    inputs.forEach((input) => {
      input.disabled = false;
    });
    btnAdd.classList.remove("disabled");
    btnAdd.setAttribute("aria-disabled", "false");
    btnAdd.removeAttribute("disabled");
    mixContainer.querySelectorAll("button[name='plus'").forEach((button) => {
      button.classList.add("disabled");
    });
    btnAdd.innerText = btnAdd.getAttribute("data-full");
    // scroll into button view
    document.querySelector(".variant-buttons").scrollIntoView(false);
  } else {
    inputs.forEach((input) => {
      input.disabled = true;
    });
    btnAdd.classList.add("disabled");
    btnAdd.setAttribute("aria-disabled", "true");
    btnAdd.setAttribute("disabled", "");
    mixContainer.querySelectorAll("button[name='plus'").forEach((button) => {
      button.classList.remove("disabled");
    });
    btnAdd.innerText = btnAdd
      .getAttribute("data-missing")
      .replace("*", 12 - count);
  }
}
